import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { isUpholsteryOption } from 'components/consumer/PDP/helpers/pdpOptionUtils';
const usePDPOptionsHasSingleOption = t0 => {
  const $ = _c(4);
  const {
    id,
    productOptions,
    slug
  } = t0;
  let t1;
  bb0: {
    if (!id && !slug || !productOptions) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          hasSingleOptionType: false,
          hasSingleOptionValue: false
        };
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    const upholsteryOptionId = (productOptions || []).map(_temp).find(isUpholsteryOption);
    if (productOptions.length === 1) {
      if (upholsteryOptionId) {
        const upholsteryOption = productOptions.find(optValue => optValue.id === upholsteryOptionId);
        if (upholsteryOption?.values?.length === 1) {
          let t2;
          if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              hasSingleOptionType: true,
              hasSingleOptionValue: true
            };
            $[1] = t2;
          } else {
            t2 = $[1];
          }
          t1 = t2;
          break bb0;
        }
      } else {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            hasSingleOptionType: true,
            hasSingleOptionValue: false
          };
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        t1 = t2;
        break bb0;
      }
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        hasSingleOptionType: false,
        hasSingleOptionValue: false
      };
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = t2;
  }
  return t1;
};
export default usePDPOptionsHasSingleOption;
function _temp(t0) {
  const {
    id: t1
  } = t0 === undefined ? {} : t0;
  const sId = t1 === undefined ? 0 : t1;
  return sId;
}